'use strict';

import axios from 'axios';

global = typeof global !== 'undefined' ? global : window;

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

axios.interceptors.request.use(
    function (config) {
        config.headers['ForceLang'] = global.config.lang;

        // Do something before request is sent
        return config;
    },
    function (error) {
        // Do something with request error
        return Promise.reject(error);
    }
);

export default axios;
